import i18n from '../../../i18n/index'
export default {
  data () {
    return {
      rowsPerPageItems: [5, 10, 15, 25],
      headers: [
        {
          text: i18n.t('headers.state'),
          sortable: false,
          value: 'resource'
        },
        {
          text: i18n.t('headers.city'),
          value: 'name',
          sortable: true
        },
        {
          text: i18n.t('headers.no-coverage'),
          sortable: false,
          value: 'noCoverage'
        },
        {
          text: i18n.t('headers.days-response'),
          sortable: false,
          value: 'responseDays'
        },
        {
          text: 'ELIMINAR',
          sortable: false,
          value: 'action'
        }
      ],
      createValue: false,
      value: null,
    }
  },
  props: {
    deletebranch: {
      type: Function,
      default: () => { }
    },
    editBranch: {
      type: Function,
      default: () => { }
    },
    editNoCoverage: {
      type: Function,
      default: () => { }
    },
    branchCities: { type: Array, default: [] }
  },
  watch: {
    props () {
      this.resetResponseDays()
  }
},
  methods: {
    deleteCity (city) {
      const index = this.branchCities.findIndex(c => c.id === city.id)
      this.deletebranch(city)
      this.branchCities.splice(index, 1)
      this.$emit('pushData', this.branchCities)
      this.$notify({
        group: 'app',
        type: 'error',
        text: i18n.t('justification-alert')
      })
    },
    onRowClick (noCoverage, stateName, municipalityName) {
      this.$emit('row-click', noCoverage, stateName, municipalityName)
    },
    resetResponseDays (item) {
      item.responseDays = 0
    },
    onRowClickResponseDays (responseDays, stateName, municipalityName) {
      const item2 = [this.value, responseDays,stateName, municipalityName]
      this.$emit('row-click-response-days', item2)
    },
    validateInputRespondeDays () {
      var input = document.getElementById('responseDays')
      if (input) {
        input.addEventListener('keypress', function () {
        if (input.value.length >= 1) {
          this.value = input.value = input.value.slice(0, 1)
          }
        })
        this.value = input.value
      }
    },
    editCityResponseDays (city) {
      city.previousValue = this.value
      this.editBranch(city)
    },
    editCityNoCoverage (city) {
      city.previousValue = this.value
      this.editNoCoverage(city)
    }
  }
}
